import * as Yup from 'yup';
import { createSortSchema, createPaginationSchema } from '@emfood/shared';

export const UserListFilterSchema = Yup.object({
  searchTerm: Yup.string().max(50, 'Search term must be less than 50 characters').optional(),
  accountStatus: Yup.mixed<'active' | 'inactive' | ''>()
    .oneOf(['active', 'inactive', ''] as const)
    .optional(),
  roles: Yup.array().of(Yup.string().required()).optional(),
});

export const UserListSearchParamsSchema = UserListFilterSchema.concat(
  createPaginationSchema({
    defaultPage: 1,
    defaultPageSize: 25,
    allowedPageSizes: [25, 50, 100],
  })
).concat(
  createSortSchema(['firstName', 'lastName', 'email', 'createdAt'] as const, {
    defaultSortOrder: 'asc',
    defaultSortBy: 'email',
  })
);
